import { Link } from 'react-router-dom'
import { FiMail, FiPhone, FiMapPin, FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi'

export default function Footer() {

    const currentLanguage = localStorage.getItem('app_lang')

    return (
        <footer className="bg-gray-900 mt-auto">

            {/* 
            <div
                style={{
                    height: '100px',
                    backgroundImage: 'url(prefooter-shevica-img.jpg)',
                    backgroundSize: 'auto 100px',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundColor: '#2C275F'
                }}
            /> 
            */}

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
                    {/* Brand */}
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center space-x-3 mb-4">
                            {/* Small logo — place your file at frontend/public/small_logo.png (or .svg/.webp) */}
                            <img
                                src="/small-logo.png"
                                alt={window.t('bileti_blagoevgrad')}
                                className="h-8 w-auto object-contain"
                                style={{
                                    height: '50px',
                                    marginTop: '-5px',
                                    position: 'absolute'
                                }}
                            />
                            <span className="font-semibold text-white !ml-[65px]">{window.t('bileti_blagoevgrad')}</span>
                        </div>
                        <p className="text-gray-400 mb-4 max-w-md">
                            {window.t('vashata_vodeshta_destinatsiya_')}
                        </p>
                        <div className="flex space-x-4">
                            <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                                <FiFacebook className="w-5 h-5" />
                            </a>
                            <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                                <FiTwitter className="w-5 h-5" />
                            </a>
                            <a href="#" className="text-gray-400 hover:text-primary-400 transition-colors">
                                <FiInstagram className="w-5 h-5" />
                            </a>
                        </div>
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">{window.t('barzi_vrazki')}</h3>
                        <ul className="space-y-2">
                            <li>
                                <Link to="/" className="text-gray-400 hover:text-white transition-colors">
                                    {window.t('razgledayte_sabitiyata')}
                                </Link>
                            </li>
                            <li>
                                <Link to="/my-tickets" className="text-gray-400 hover:text-white transition-colors">
                                    {window.t('moite_bileti')}
                                </Link>
                            </li>

                            <li>
                                <Link to="/help" className="text-gray-400 hover:text-white transition-colors">
                                    {window.t('pomoshten_tsentar')}
                                </Link>
                            </li>
                        </ul>
                    </div>

                    {/* Contact */}
                    <div>
                        <h3 className="text-white font-semibold mb-4">{window.t('kontakti')}</h3>
                        <ul className="space-y-3">
                            <li className="flex items-center gap-2 text-gray-400">
                                <FiMail className="w-4 h-4" />
                                delo@blagoevgrad.bg
                            </li>
                            <li className="flex items-center gap-2 text-gray-400">
                                <FiPhone className="w-4 h-4" />
                                073 867701
                            </li>
                            <li className="flex items-center gap-2 text-gray-400">
                                <FiMapPin className="w-4 h-4" />
                                {currentLanguage === 'en'
                                    ? <>Blagoevgrad, 2700 <br />"Georgi Izmirliev" Sq. No. 1</>
                                    : <>Благоевград, 2700 <br />пл. "Георги Измирлиев" №1</>
                                }
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
                    <p className="text-gray-500 text-sm">
                        © {new Date().getFullYear()} {window.t('obshtina_blagoevgrad')}
                    </p>
                    <div className="flex space-x-6 mt-4 md:mt-0">
                        <a href="#" className="text-gray-500 hover:text-gray-400 text-sm">
                            {window.t('politika_za_poveritelnost')}
                        </a>
                        <a href="#" className="text-gray-500 hover:text-gray-400 text-sm">
                            {window.t('usloviya_za_polzvane')}
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}
